export const guestComps = {
  detail: {
    nav: {
      overview: "Información",
      bookings: "Reservas",
      checkins: "Check-ins",
      invoicing: "Facturación",
    },
    personalInfo: "Información personal",
    contactInfo: "Información de contacto",
    residenceInfo: "Información de residencia",
    fields: {
      firstName: "Nombre",
      lastName: "Apellido",
      document: "Documento",
      nationality: "Nacionalidad",
      country: "País",
      birthDate: "Fecha de nacimiento",
      email: "Email",
      whatsapp: "WhatsApp",
      countryResidence: "País de residencia",
      cityResidence: "Ciudad de residencia",
      relationship: "Relación",
    },
    cols: {
      code: "Código",
      accommodation: "Alojamiento",
      checkIn: "Check-in",
      checkOut: "Check-out",
      status: "Estado",
      total: "Total",
      guest: "Huésped",
      booking: "Reserva",
      entryDate: "Fecha entrada",
      date: "Fecha",
    },
    confirmed: "Confirmada",
    fiscalProfile: "Perfil fiscal registrado",
    legalName: "Nombre legal",
    taxId: "NIF / ID fiscal",
    type: "Tipo",
    company: "Empresa",
    individual: "Particular",
    invoicesIssued: "Facturas emitidas",
    empty: {
      bookings: "No hay reservas registradas para este huésped.",
      checkins: "No hay check-ins registrados para este huésped.",
      invoices: "No hay facturas emitidas para este huésped.",
    },
    noPdf: "Sin PDF",
    status: {
      sent: "Emitida",
      processing: "Procesando",
      error: "Error",
      pending: "Pendiente",
    },
    close: "Cerrar",
  },
  form: {
    editTitle: "Editar cliente",
    newTitle: "Nuevo cliente",
    subtitle: "Datos de contacto y facturación para próximas reservas y facturas.",
    subtitleEmbedded: "Completa el perfil y volverás a la factura sin perder los cargos.",
    backToInvoice: "Volver a la factura",
    close: "Cerrar",
    customerTypeAria: "Tipo de cliente",
    typeIndividual: "Particular",
    typeIndividualHelp: "Persona física",
    typeCompany: "Empresa",
    typeCompanyHelp: "Persona jurídica",
    identity: "Identidad",
    identityDesc: "Información que identifica al destinatario de la factura.",
    name: "Nombre",
    namePlaceholder: "Juan",
    lastName: "Apellidos",
    lastNamePlaceholder: "García López",
    legalName: "Razón social",
    legalNamePlaceholder: "Empresa Ejemplo S.L.",
    docTaxId: "NIF / CIF / VAT",
    docFiscal: "Documento fiscal",
    docPlaceholderIndividual: "DNI, NIE o pasaporte",
    docType: "Tipo de documento",
    select: "Seleccionar",
    docDni: "DNI",
    docNie: "NIE",
    docPassport: "Pasaporte",
    docOther: "Otro documento",
    contact: "Contacto",
    contactDesc: "Canales para enviar la factura o contactar al cliente.",
    email: "Email",
    emailPlaceholder: "cliente@email.com",
    phone: "Teléfono",
    fiscalAddress: "Domicilio fiscal",
    fiscalAddressDesc: "Se usa como dirección del destinatario en una factura completa.",
    country: "País",
    address: "Dirección",
    addressPlaceholder: "Calle, número y piso",
    city: "Ciudad",
    cityPlaceholder: "Madrid",
    state: "Provincia / Estado",
    postalCode: "Código postal",
    postalPlaceholder: "28001",
    requiredNote: "* Campos necesarios para el perfil fiscal",
    backToInvoiceShort: "Volver a factura",
    cancel: "Cancelar",
    saving: "Guardando…",
    saveChanges: "Guardar cambios",
    createClient: "Crear cliente",
    err: {
      name: "Indica el nombre.",
      lastName: "Indica los apellidos.",
      legalName: "Indica la razón social.",
      taxId: "La identificación fiscal es obligatoria para empresas.",
      country: "Selecciona el país.",
      address: "Indica la dirección fiscal.",
      city: "Indica la ciudad.",
      postalCode: "Indica el código postal.",
      email: "Introduce un email válido.",
      saveFailed: "No se pudo guardar el cliente.",
    },
  },
  list: {
    title: "Clientes de facturación",
    subtitle: "Perfiles fiscales reutilizables para emitir y consultar facturas",
    searchLabel: "Buscar clientes",
    searchPlaceholder: "Nombre, email, teléfono o documento…",
    clearSearch: "Limpiar búsqueda",
    exporting: "Exportando...",
    exportClients: "Exportar clientes",
    newClient: "Nuevo cliente",
    cols: {
      fiscalClient: "CLIENTE FISCAL",
      contact: "CONTACTO",
      fiscalDocument: "DOCUMENTO FISCAL",
      country: "PAÍS",
      linkedBookings: "RESERVAS VINC.",
      invoices: "FACTURAS",
      actions: "ACCIONES",
    },
    company: "Empresa",
    individual: "Particular",
    noEmail: "Correo no asignado",
    noPhone: "Teléfono no asignado",
    viewInvoicesTitle: "Ver {count} factura de este huésped | Ver {count} facturas de este huésped",
    invoicesCount: "{count} factura | {count} facturas",
    noInvoices: "Sin facturas",
    editClient: "Editar cliente",
    edit: "Editar",
    viewDetail: "Ver detalle",
    view: "Ver",
    emptySearchTitle: "No encontramos perfiles fiscales",
    emptySearchSub: "No hay clientes de facturación que coincidan con “{term}”.",
    emptyTitle: "Aún no hay clientes de facturación",
    emptySub: "Crea un perfil fiscal al emitir una factura o guárdalo ahora para reutilizarlo después.",
    createFirst: "Crear primer cliente",
    selectedClient: "Cliente seleccionado",
  },
  internalName: {
    addBtn: "nombre interno",
    title: "Nombre interno",
    hint: "Solo lo ves tú. Aparece delante del nombre público en tus listas y calendarios.",
    removeWarn: "Se quitará de tus listas. Los mensajes de códigos de acceso y el Agente IA dejarán de indicar de qué alojamiento se trata.",
    edit: "Editar",
    cancel: "Cancelar",
    removing: "Quitando…",
    confirmRemove: "Sí, quitar",
    remove: "Quitar",
    editTitle: "Editar nombre interno",
    addTitle: "Añadir nombre interno",
    eyebrow: "Nombre interno del alojamiento",
    modalHint: "Es un nombre privado para que reconozcas el alojamiento de un vistazo (por ejemplo «Ático Roser» o «Segundo»). Tus huéspedes nunca lo ven.",
    placeholder: "Ático Roser",
    previewLabel: "Lo verás así",
    saving: "Guardando…",
    save: "Guardar",
    saveFailed: "No se pudo guardar el nombre interno.",
  },
};
